import React from 'react';
import { Typography } from '@mui/material';
import PersonSearchRoundedIcon from '@mui/icons-material/PersonSearchRounded';

export default function NoDataAvailable({ message }) {
  return (
    <div
      style={{
        minHeight: '200px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
      }}
      data-testid='no_data_available'
    >
      <PersonSearchRoundedIcon sx={{color: '#B0B9C7', height: 50}}/>
      <Typography
        sx={{
          color: '#B0B9C7',
          fontSize: { xs: '14px', sm: '16px' },
          fontWeight: 'bold',
          marginTop: '5px'
        }}
      >
        {message || 'No Data available yet'}
      </Typography>
    </div>
  );
}
